<template>
    <Modal v-model="modal"
           width="500"
           :title="$t('存储变更')"
           class="logModal"
           :mask-closable="false"
           @on-cancel="cancel">
        <div class="content">
            <Form ref="editInvoiceForm"
                  :model="formData"
                  :rules="rule"
                  :label-width="120"
                  :label-colon="true">
                <FormItem :label="$t('已绑定存储')"
                          prop="bindStorage">
                    <Select v-model="sfsId"
                            style="width: 300px;"
                            @on-change="changeSFS">
                        <Option v-for="item in sfsList"
                                :key="item.shareId"
                                :value="item.shareId">{{ item.shareName }}</Option>
                    </Select>
                </FormItem>
                <div v-if="sfsId&&clusterType == 'SAASShare'">
                    <FormItem :label="$t('已用容量')"
                              prop="used">
                        {{used}}GB
                    </FormItem>
                    <FormItem :label="$t('最大容量')"
                              prop="maxStorage">
                        {{total}}GB
                    </FormItem>
                    <FormItem :label="$t('调整后容量')"
                              prop="size">
                        <Input style="width:60px;"
                               v-model="formData.size"></Input>&nbsp;GB
                        <Tooltip theme="light"
                                 style="margin:0px 0 0 3px;vertical-align: middle;cursor: pointer;">
                            <i class="icon-prompt-1-o tips-icon-prompt"></i>
                            <div slot="content">
                                <p>
                                    {{$t('每七天可扩容')}}{{maxUpgradeCount}}{{$t('次')}}，{{$t('缩容')}}{{maxDegradeCount}}{{$t('次')}}
                                </p>
                                <p>{{$t('调整后容量必须大于已使用容量')}}</p>
                                <p>{{$t('每次扩缩容限制不得大于')}}{{maxTimesStorage}} GB</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                </div>
            </Form>
        </div>
        <div slot="footer">
            <Button class="ivu-btn-text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    @click="submit"
                    :loading="loading">{{$t('确定')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
export default {
    name: 'StorageChangeModal',
    data () {
        return {
            clusterType: null,
            modal: false,
            sfsId: '',
            sfsList: [],
            loading: false,
            total: 0,
            used: 0,
            maxTimesStorage: 0,
            maxTimes: 0,
            id: null,
            formData: {
                size: 0
            },
            rule: {
                size: [
                    {
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            const reg = /^[1-9]+[0-9]*$/
                            if (Number(value) <= Number(this.used)) {
                                callback(this.$i18n.t('调整后容量必须大于已使用容量'))
                            } else if (Math.abs(Number(this.total) - Number(value)) > Number(this.maxTimesStorage)) {
                                callback(this.$i18n.t('每次扩缩容限制不得大于' + this.maxTimesStorage + 'GB'))
                            } else if (Number(this.total) === Number(value)) {
                                callback(this.$i18n.t('调整后容量不能和当前容量相同'))
                            } else if (!reg.test(value)) {
                                callback(new Error(this.$t('请输入整数')))
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            },
            list: [],
            maxUpgradeCount: 0,
            maxDegradeCount: 0,
            type: ''
        }
    },
    computed: {
        cloudEnvType () {
            let envType = null
            for (const i in this.sfsList) {
                if (this.sfsId !== null && String(this.sfsList[i].shareId) === String(this.sfsId)) {
                    envType = this.sfsList[i].cloudEnvType
                }
            }
            return envType
        }
    },
    methods: {
        openModal (data, clusterType) {
            this.clusterType = clusterType
            this.sfsList = data
            this.sfsList = this.sfsList.filter(item => !item.isVirtual && !item.isClusterDefault)
            if (this.sfsList && this.sfsList.length > 0) {
                const choosedData = this.sfsList[0]
                this.sfsId = choosedData.shareId || null
                this.total = choosedData.size || 0
                this.used = choosedData.usedSize || 0
                this.id = this.sfsId
                this.formData.size = choosedData.size || 0
                this.type = choosedData.type
            }
            this.getConfig()
            this.modal = true
        },
        changeSFS (id) {
            if (id && id !== null) {
                const choosedData = this.sfsList.find(item => item.shareId + '' === id + '')
                this.id = id
                this.total = choosedData.size || 0
                this.used = choosedData.usedSize || 0
                this.formData.size = choosedData.size || 0
                this.type = choosedData.type
                this.config()
            }
        },
        cancel () {
            this.modal = false
            this.sfsId = ''
            this.id = ''
            this.sfsList = []
            this.loading = false
            this.total = null
            this.used = null
            this.formData.size = null
            this.clusterType = null
            this.type = ''
        },
        submit () {
            // 共享资源池
            if (this.clusterType === 'SAASShare') {
                this.$refs.editInvoiceForm.validate(valid => {
                    if (valid) {
                        if (this.total > this.formData.size) {
                            this.modal = false
                            this.$Modal.confirm({
                                title: this.$t('注意'),
                                content: this.$t(
                                    '缩容当前资源有可能影响其他关联资源正常使用，例如会影响正在执行的训练作业，出现作业执行失败情况。请谨慎操作。'
                                ),
                                onOk: () => {
                                    this.subPost()
                                }
                            })
                        } else {
                            this.subPost()
                        }
                    }
                })
            } else {
                // 专属资源池
                this.$router.push({
                    path: '/mgt/change',
                    query: { id: this.sfsId, type: this.type, envType: this.cloudEnvType || 'HCSO' }
                })
            }
        },
        subPost () {
            this.loading = true
            this.axios.post(this.urlFormat(API.GET_SHARE_HPC_ID_SIZE, false, [this.id, this.formData.size])).then(res => {
                this.loading = false
                if (res && res.code === 200) {
                    this.$emit('refresh')
                    this.cancel()
                }
            }).catch(e => {
                this.loading = false
            })
        },
        getConfig () {
            this.axios.get(this.urlFormat(API.PUT_ALL_CONFIG + '?configTypes=other_config&configTypes=hpc_config&configTypes=sfs_config', true)).then(res => {
                res.forEach(element => {
                    if (element.configKey === 'hpc.sfs.base.config') {
                        this.list = JSON.parse(element.configValue) || []
                        this.config()
                    }
                })
            })
        },
        config () {
            const list = this.list.find(item => item.serviceType === this.type)
            this.maxTimesStorage = list.changeMaxCapacity
            this.maxUpgradeCount = list.maxUpgradeCount
            this.maxDegradeCount = list.maxDegradeCount
        }
    }
}
</script>
